import { useEffect, useState } from 'react';
import { certificateAPI } from '../api/certificateAPI';

/**
 * Server-confirmed admin access for the signed-in user. The backend decides
 * (admin/certadmin role or ADMIN_EMAILS), so the pages never trust the client role.
 */
export function useAdminAccess(user) {
  const userId = user?.id || user?.user_id || null;
  const [state, setState] = useState({ checking: true, isAdmin: false, passcodeEnabled: false });

  useEffect(() => {
    let cancelled = false;
    setState((prev) => ({ ...prev, checking: true }));
    certificateAPI.getAdminAccess().then((result) => {
      if (!cancelled) setState({ checking: false, ...result });
    });
    return () => {
      cancelled = true;
    };
  }, [userId]);

  return state;
}
